/** @format */
import { InjectionToken, Provider } from '@angular/core';
import * as angular from 'angular';

/* **************************************************************************************
 * NOTE: Don't add any new upgrade configs here without a very good reason. If you need *
 * functionality from a legacy AngularJS service, your first choice should always be to *
 * move/reimplement that functionality to a new/existing Angular service.               *
 ************************************************************************************** */

const angularJSInjectorName = '$injector';

/**
 * @deprecated
 */
export const COURSE_UNIT_INFO_MODAL = new InjectionToken<any>('courseUnitInfoModal');
export const courseUnitInfoModalFactory = (injector: angular.auto.IInjectorService) => injector.get('courseUnitInfoModal');
export const courseUnitInfoModalProvider: Provider = {
    provide: COURSE_UNIT_INFO_MODAL,
    useFactory: courseUnitInfoModalFactory,
    deps: [angularJSInjectorName],
};

/**
 * @deprecated
 */
export const STUDY_PROGRESS_GRAPH_DROPDOWN_CONTENT_FETCHER = new InjectionToken<any>('studyProgressGraphDropDownContentFetcher');
export const studyProgressGraphDropDownContentFetcherFactory = (injector: angular.auto.IInjectorService) =>
    injector.get('studyProgressGraphDropDownContentFetcher');
export const studyProgressGraphDropDownContentFetcherProvider: Provider = {
    provide: STUDY_PROGRESS_GRAPH_DROPDOWN_CONTENT_FETCHER,
    useFactory: studyProgressGraphDropDownContentFetcherFactory,
    deps: [angularJSInjectorName],
};

/**
 * @deprecated
 */
export const ENROLMENT_MODAL_SERVICE = new InjectionToken<any>('enrolmentModalService');
export const enrolmentModalService = (injector: angular.auto.IInjectorService) => injector.get('enrolmentModalService');
export const enrolmentModalServiceProvider: Provider = {
    provide: ENROLMENT_MODAL_SERVICE,
    useFactory: enrolmentModalService,
    deps: [angularJSInjectorName],
};

/**
 * @deprecated
 */
export const UI_CONTEXT = new InjectionToken<any>('uiContext');
export const getUiContext = (injector: angular.auto.IInjectorService) => injector.get('uiContext');
export const uiContextProvider = {
    provide: UI_CONTEXT,
    useFactory: getUiContext,
    deps: [angularJSInjectorName],
};
